import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.restoreScroll()
  }

  getScrollContainer() {
    return document.querySelector('.layout-content')
  }

  saveScroll() {
    const container = this.getScrollContainer()
    if (!container) return
    const scrollKey = `scroll_${window.location.pathname}${window.location.search}`
    sessionStorage.setItem(scrollKey, container.scrollTop.toString())
  }

  restoreScroll() {
    const container = this.getScrollContainer()
    if (!container) return
    const scrollKey = `scroll_${window.location.pathname}${window.location.search}`
    const savedScroll = sessionStorage.getItem(scrollKey)

    if (savedScroll) {
      setTimeout(() => {
        container.scrollTop = parseInt(savedScroll, 10)
        // Clear the saved position after restoring so it only happens once (on back button)
        sessionStorage.removeItem(scrollKey)
      }, 100)
    }
  }
}
